import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  getLocationRulesSuccess,
  getLocationRulesFailure,
  createLocationRuleSuccess,
  createLocationRuleFailure,
  updateLocationRuleSuccess,
  updateLocationRuleFailure,
  deleteLocationRuleSuccess,
  deleteLocationRuleFailure,
  rescrapeLocationRuleSuccess,
  rescrapeLocationRuleFailure,
} from "./actions";
import {
  GET_LOCATION_RULES,
  CREATE_LOCATION_RULE,
  UPDATE_LOCATION_RULE,
  DELETE_LOCATION_RULE,
  RESCRAPE_LOCATION_RULE,
} from "./constants";

export function* getLocationRulesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, type } = payload;
  try {
    let url = `/api/location/${locationId}/rules`;
    if (type) url += `?type=${type}`;
    const { data } = yield call(api(token).get, url);
    yield put(getLocationRulesSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getLocationRulesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error fetching location rules"));
  }
}

export function* createLocationRuleSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/location/${locationId}/rules`,
      formData,
    );
    yield put(createLocationRuleSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
    yield put(successAlert("Rule created successfully"));
  } catch (e) {
    yield put(createLocationRuleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error creating rule"));
  }
}

export function* updateLocationRuleSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, ruleId, formData } = payload;
  try {
    const { data } = yield call(
      api(token).put,
      `/api/location/${locationId}/rules/${ruleId}`,
      formData,
    );
    yield put(updateLocationRuleSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
    yield put(successAlert("Rule updated successfully"));
  } catch (e) {
    yield put(updateLocationRuleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error updating rule"));
  }
}

export function* deleteLocationRuleSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, ruleId } = payload;
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/location/${locationId}/rules/${ruleId}`,
    );
    yield put(deleteLocationRuleSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
    yield put(successAlert("Rule deactivated"));
  } catch (e) {
    yield put(deleteLocationRuleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error deleting rule"));
  }
}

export function* rescrapeLocationRuleSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, ruleId } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/location/${locationId}/rules/${ruleId}/rescrape`,
    );
    yield put(rescrapeLocationRuleSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
    yield put(successAlert("Re-scrape job dispatched"));
  } catch (e) {
    yield put(rescrapeLocationRuleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error triggering re-scrape"));
  }
}

export default function* LocationRuleSaga() {
  yield all([
    takeEvery(GET_LOCATION_RULES, getLocationRulesSaga),
    takeEvery(CREATE_LOCATION_RULE, createLocationRuleSaga),
    takeEvery(UPDATE_LOCATION_RULE, updateLocationRuleSaga),
    takeEvery(DELETE_LOCATION_RULE, deleteLocationRuleSaga),
    takeEvery(RESCRAPE_LOCATION_RULE, rescrapeLocationRuleSaga),
  ]);
}
